import { Atom, BarChart3, Bolt, Cog } from "lucide-react";
import React from "react";

const FutureBatteryArchitectures: React.FC = () => {
  return (
    <div
      id="future-battery-architectures"
      className="min-h-full py-20 px-7 bg-gradient-to-br from-black via-gray-900 to-gray-800 text-white"
    >
      <div className="max-w-6xl mx-auto">
        <h1 className="text-3xl md:text-4xl font-bold tracking-wide mb-16">
          FUTURE BATTERY ARCHITECTURES
          <div className="w-40 h-0.5 bg-sky-400 mt-4"></div>
        </h1>

        <div className="relative grid grid-cols-1 md:grid-cols-2 gap-10 w-full mt-10">
          <div className="flex items-center gap-4 border border-gray-500 p-10 rounded-xl">
            <div className="p-3 border border-gray-500 rounded-xl">
              <Bolt className="w-7 h-7 text-cyan-300" />
            </div>
            <div>
              <h2 className="text-xl font-semibold text-cyan-300 mb-2">
                Hydrogen Cells
              </h2>
            </div>
          </div>

          <div className="flex items-center gap-4 border border-gray-500 p-10 rounded-xl">
            <div className="p-3 border border-gray-500 rounded-xl">
              <Atom className="w-7 h-7 text-cyan-300" />
            </div>
            <div>
              <h2 className="text-xl font-semibold text-cyan-300 mb-2">
                Betavoltic Cells
              </h2>
            </div>
          </div>

          <div className="flex items-center gap-4 border border-gray-500 p-10 rounded-xl">
            <div className="p-3 border border-gray-500 rounded-xl">
              <Cog className="w-7 h-7 text-cyan-300" />
            </div>
            <div>
              <h2 className="text-xl font-semibold text-cyan-300 mb-2">
                Sodium Sulphur Cells
              </h2>
            </div>
          </div>

          <div className="flex items-center gap-4 border border-gray-500 p-10 rounded-xl">
            <div className="p-3 border border-gray-500 rounded-xl">
              <BarChart3 className="w-7 h-7 text-cyan-300" />
            </div>
            <div>
              <h2 className="text-xl font-semibold text-cyan-300 mb-2">
                Solid State Cells
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FutureBatteryArchitectures;
